<template>
  <div class="text-center">
    <v-alert type="success">Выход из приложения выполнен</v-alert>
    <v-btn rounded large @click="Login">Войти</v-btn>
  </div>
</template>

<script>
export default {
  name: "Logout",
  beforeMount() {
    this.onLoaded();
  },
  methods: {
    onLoaded() {
      this.$store.dispatch("logout").then(() => {});
      this.$router.push("/login");
    },
    Login() {
      this.$router.push("/login");
    },
  },
};
</script>
